var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrapper pa-4"},[_c('h1',[_vm._v("摄像机 改变镜头视角")]),_vm._m(0),_c('p'),_c('div',{staticStyle:{"position":"relative"},attrs:{"id":"gui"}}),_c('p'),_c('p',[_vm._v(" 添加旋转镜头 "),_c('highlightjs',{attrs:{"code":`import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls.js';

//.. init函数添加:
const controls = new OrbitControls( this.camera, canvas );
// target
controls.target.set( 0, 0, 0 );
controls.update();`,"language":'js'}})],1),_c('p',[_vm._v(" 再添加GUI控制面板 "),_c('highlightjs',{attrs:{"code":`import { GUI } from 'three/examples/jsm/libs/lil-gui.module.min.js';

//.. init函数添加:
class MinMaxGUIHelper {

  constructor( obj, minProp, maxProp, minDif ) {

    this.obj = obj;
    this.minProp = minProp;
    this.maxProp = maxProp;
    this.minDif = minDif;

  }
  get min() {

    return this.obj[ this.minProp ];

  }
  set min( v ) {

    this.obj[ this.minProp ] = v;
    this.obj[ this.maxProp ] = Math.max( this.obj[ this.maxProp ], v + this.minDif );

  }
  get max() {

    return this.obj[ this.maxProp ];

  }
  set max( v ) {

    this.obj[ this.maxProp ] = v;
    // eslint-disable-next-line
    this.min = this.min; // this will call the min setter

  }

}
// GUI
const gui = new GUI();
gui.add( this.camera, 'fov', 1, 180 ).onChange( this.updateCamera );
const minMaxGUIHelper = new MinMaxGUIHelper( this.camera, 'near', 'far', 0.1 );
gui.add( minMaxGUIHelper, 'min', 0.1, 50, 0.1 ).name( 'near' ).onChange( this.updateCamera );
gui.add( minMaxGUIHelper, 'max', 0.1, 50, 0.1 ).name( 'far' ).onChange( this.updateCamera );
// position
gui.add( this.camera.position, 'x', -10, 10 ).name( 'cameraX' );
gui.add( this.camera.position, 'y', -10, 10 ).name( 'cameraY' );
gui.add( this.camera.position, 'z', -10, 10 ).name( 'cameraZ' );`,"language":'js'}})],1),_c('p',[_c('highlightjs',{attrs:{"code":`// gui 元素移动到 #gui 下面
const guiElement = document.querySelector('#gui');
guiElement.appendChild(gui.domElement);
gui.domElement.style.position = 'absolute';
// zindex防止覆盖到左侧菜单
guiElement.style.zIndex = '1';
guiElement.style.height = '200px';`,"language":'js'}})],1),_c('p',[_vm._v(" 添加地面mesh "),_c('highlightjs',{attrs:{"code":`{
  const planeSize = 10;
  const loader = new THREE.TextureLoader();
  const texture = loader.load( 'https://threejs.org/manual/examples/resources/images/checker.png' );
  texture.wrapS = THREE.RepeatWrapping;
  texture.wrapT = THREE.RepeatWrapping;
  texture.magFilter = THREE.NearestFilter;
  //texture.colorSpace = THREE.SRGBColorSpace;
  const repeats = planeSize / 2;
  texture.repeat.set( repeats, repeats );

  const planeGeo = new THREE.PlaneGeometry( planeSize, planeSize );
  const planeMat = new THREE.MeshPhongMaterial( {
    map: texture,
    side: THREE.DoubleSide,
  } );
  const mesh = new THREE.Mesh( planeGeo, planeMat );
  mesh.rotation.x = Math.PI * - .5;
  this.scene.add( mesh );
}`,"language":'js'}})],1),_vm._m(1)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('p',[_c('canvas',{staticStyle:{"border":"1px solid","width":"100%"},attrs:{"id":"c3"}})])
},function (){var _vm=this,_c=_vm._self._c;return _c('p',[_c('a',{attrs:{"href":"https://threejs.org/manual/#zh/cameras"}},[_vm._v("https://threejs.org/manual/#zh/cameras")])])
}]

export { render, staticRenderFns }